import { render, staticRenderFns } from "./DebrisBoxDialog.vue?vue&type=template&id=5c976a90&scoped=true&"
import script from "./DebrisBoxDialog.vue?vue&type=script&lang=js&"
export * from "./DebrisBoxDialog.vue?vue&type=script&lang=js&"
import style0 from "./DebrisBoxDialog.vue?vue&type=style&index=0&id=5c976a90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c976a90",
  null
  
)

export default component.exports